import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Close from "@engineering/icons/close";
import { Button, Ui } from "@silvertours/front-shared";
import { Container, Element, Header } from "./MarketPicker.styles";
var MarketPicker = function(_param) {
    var redirectInfo = _param.selectedMarket.redirectInfo, markets = _param.markets, selectMarket = _param.selectMarket, onClose = _param.onClose, onSubmit = _param.onSubmit, selectedMarket = _object_without_properties(_param.selectedMarket, [
        "redirectInfo"
    ]), translatedContent = _object_without_properties(_param, [
        "selectedMarket",
        "markets",
        "selectMarket",
        "onClose",
        "onSubmit"
    ]);
    var handleSubmit = function() {
        onSubmit(selectedMarket);
    };
    return /*#__PURE__*/ _jsxs(Container, {
        hasHeader: !!translatedContent.header,
        children: [
            /*#__PURE__*/ _jsxs(Header, {
                children: [
                    /*#__PURE__*/ _jsx(Ui.Typography, {
                        as: "h3",
                        children: translatedContent.header
                    }),
                    onClose && /*#__PURE__*/ _jsx(Ui.IconButton, {
                        icon: Close,
                        title: translatedContent.close,
                        onClick: onClose,
                        size: "large"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Element, {
                children: /*#__PURE__*/ _jsx(Ui.Dropdown, {
                    label: translatedContent.countryLabel,
                    options: markets.map(function(param) {
                        var country = param.country;
                        return {
                            label: country.name,
                            value: country.code
                        };
                    }),
                    value: selectedMarket.country.code,
                    onChange: function(e) {
                        return selectMarket(markets[e.target.selectedIndex]);
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Element, {
                children: /*#__PURE__*/ _jsx(Ui.Dropdown, {
                    label: translatedContent.languageLabel,
                    options: markets.map(function(param) {
                        var language = param.language;
                        return {
                            label: language.name,
                            value: language.code
                        };
                    }),
                    value: selectedMarket.language.code,
                    disabled: true
                })
            }),
            redirectInfo && /*#__PURE__*/ _jsx(Element, {
                children: /*#__PURE__*/ _jsxs(Ui.Message, {
                    headline: redirectInfo.header,
                    children: [
                        redirectInfo.text,
                        /*#__PURE__*/ _jsx("br", {}),
                        redirectInfo.link && /*#__PURE__*/ _jsx(Ui.TextLink, {
                            href: redirectInfo.link.url,
                            text: redirectInfo.link.text
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "primary",
                fullWidth: true,
                onClick: handleSubmit,
                disabled: selectedMarket.redirectOnly,
                children: translatedContent.saveButtonText
            })
        ]
    });
};
export { MarketPicker };
